
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.83 9.17l-5.66 5.66m5.66 0L9.17 9.17M12 21v0a9 9 0 01-9-9v0a9 9 0 019-9v0a9 9 0 019 9v0a9 9 0 01-9 9z"}})])
          )
        }
      }
    